// extracted by mini-css-extract-plugin
export var darkMode = "_2j-0";